export type SalonKpiData = {
  salonId: string;
  id: string;
  kpi: SalonKPIs;
  selectedKpi: string[];
  globalBenchmark: BenchmarkData;
  benchmarkData: BenchmarkData;
};

export type SalonKPIs = {
  [kpi: string]: KpiItemValues;
};

type BenchmarkData = {
  minValue: number;
  kpiRecommendations: string[];
  [kpi: string]: BenchmarkItemValues | string | number | string[];
};

export type KpiItemValues = {
  value: string;
  status: string;
  planType: 'guest_plan' | 'team_plan' | 'higher_tickets_plan';
  prefix: string;
  suffix: string;
};

export type BenchmarkItemValues = {
  prefix: string;
  suffix: string;
  minValue: number;
  maxValue: number;
};

export enum KpiTitle {
  tnTransactionsBmrk = '# OF TRANSACTIONS',
  pGuestsPurchasing = '% SERVICE GUESTS PURCHASING PRODUCT',
  rprt = 'RPRT: RETAIL PER RETAIL TRANSACTION',
  pRetailSales = '% RETAIL SALES',
  existGuestRetention = 'EXISTING GUEST RETENTION',
  pGuestsPrebooked = '% SERVICE GUESTS PRE-BOOKED',
  newGuestRetention = 'NEW GUEST RETENTION',
  rpct = 'RPCT: RETAIL PER CLIENT TICKET/TRANSACTION',
  treatmentTransactions = '% TREATMENT TRANSACTIONS',
  pColorTransactions = '% COLOR TRANSACTIONS',
  spRetention = 'SERVICE PROVIDER RETENTION',
}

export enum KpiStatus {
  below = 'Below Benchmark',
  met = 'At Benchmark',
  above = 'Above Benchmark',
}
